<template>
<fieldset class="form__fieldset">
    <div class="form__fieldset-header">
        <h4><slot name='title'></slot></h4>
    </div>
    <div class="form__fieldset-body">
        <slot name="body"></slot>
    </div>
</fieldset>
</template>

<script>
  export default {

  }

</script>
